export function getActionName(actionType) {
  if (!actionType || typeof actionType !== "string") return null;
  return actionType.split("_").slice(0, -1).join("_");
}
